import TermsAndConditionsLayout from "./terms_and_conditions_layout";

const TermsAndConditionsPage = () => {
  return (
      <TermsAndConditionsLayout />
  );
};

export default TermsAndConditionsPage;